const SDK_VERSION = '7.111.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
